<template lang="pug">
.parent
  ProductPage.custom-bar(:product="product" :showTabsSlot="true" :showMainSlot="true")
    template(#title="slotProps")
      ProductTitle(:product="product" :show-h1="slotProps.showH1")
    template(#tabs)
      RenderBlock(:block="slots.tabs" :product="product")
    template(#media)
      Media(
        :gallery="gallery"
        layout="desktop"
        v-model="selectedImg"
        :product="product"
      )
        template(#overlay="data")
          .shaft-image(v-if="data.idx === 3")
            //- shaft-multi-image( v-if="sku === 'CUSTOMOHIOPOWER_NEW'" :options="options")
            //- shaft-image( v-else :options="options")
    template(#rhpa)
      product-badges.rhpa-badges( :product="product" )
      loading(v-if="buyRequest.loading")
      rhpa(:buy-request="buyRequest" @change="$emit('change')"  v-else)
        template(#rhpaBody)
          Swatches(label="Choose Team" :options="logos" v-model="options.team" @update:modelValue="changeTeam($event)")
        template(#rhpaFooter)
          .terms
            b {{__('TERMS')}}:&nbsp;
            span {{__('All custom sales are final and cannot be returned. In addition to your transit time, please allow 3-5 business days to assemble your Ohio Bar.') }}
          rhpa-footer.buy-btn(:buy-request="buyRequest" :validate="createRecipe" :disabled="false")
    template(#flexible)
      RenderBlock(:block="slots.flexible" :product="product")
    template(#main)
      RenderBlock(:block="slots.main" :product="product")
    template(#full)
      RenderBlock(:block="slots.full" :product="product")
    template(#bottom)
      ProductBottom(:product="product")
</template>
<script setup lang="ts">
import { ref, computed, defineAsyncComponent } from 'vue'
import { NFL, OHIO_1 } from './nfl-data'
import { useProductStore } from '@/js/stores/productStore'
import { useRogue } from '@/js/services/Rogue'
import { createBuyRequest } from '@/js/helpers/buy-request'
import type { BuyRequest, Product } from '@/js/services/RogueTypes'

const ProductTitle = defineAsyncComponent(() => import('../../../components/rhpa/product-title.vue'))
const RhpaFooter = defineAsyncComponent(() => import('../../../components/rhpa/rhpa-footer.vue'))
const Rhpa = defineAsyncComponent(() => import('../../../components/rhpa/rhpa.vue'))
const ProductBadges = defineAsyncComponent(() => import('../../../components/rhpa/badges.vue'))
const ProductBottom = defineAsyncComponent(() => import('@/js/pages/product/product-bottom.vue'))

const rogue = useRogue()
const productStore = useProductStore()

const props = defineProps<{
  product: Product,
  buyRequest: BuyRequest
}>()

const emit = defineEmits<{
  change: [],
  input: [buyRequest: BuyRequest]
}>()

// These are the RHPA logos
const logos = NFL.map(t => ({
  value : t.code,
  image : t.thumb,
  label : `${t.city} ${t.name}`,
}))

function createRecipe() {

}

const config = computed(() => productStore.products[props.buyRequest.productId])

// This is for the product gallery
const selectedImg = ref(0)

// This is for the RHPA selections
const options = ref<{team: string}>({ team: 'ARI' })

type RBSlots = {flexible: unknown, full: unknown, main: unknown}

// Called when the customer picks a new team
function changeTeam(team: string) {
  options.value.team = team
  const settings = OHIO_1[team]

  const simpleId = config.value.childrenIds?.find(child => rogue.getProductById(child)?.sku.endsWith(`-${settings.shaft}`))

  const opts: {[key: string] : number} = { }

  config.value.customOptions?.forEach(opt => {
    if (opt.title === 'Choose Sleeve Finish') {
      const optId = opt.values.find(v => v.sku === settings.sleeve)?.id
      opts[opt.id] = optId || opt.values[0].id
    }
    if (opt.title === 'Choose Bushing Finish') {
      const optId = opt.values.find(v => v.sku === settings.bushing)?.id
      opts[opt.id] = optId || opt.values[0].id
    }
  })

  const buyRequest = createBuyRequest(config.value, rogue, simpleId, opts)
  // todo set recipe

  Object.keys(opts).forEach(optId => props.buyRequest.options![optId] = opts[optId])
  props.buyRequest.children![0].productId = buyRequest.children![0].productId

  emit('input', buyRequest)
}

const slots = computed<RBSlots>(() => props.product?.roguebuilder?.slots || {} as RBSlots)
const gallery = computed(() => props.product.gallery?.map((image, i) => {
  // First and third images do not have the bushings / sleeves in them so we do not append that part to the SKU
  if (i === 0 || i === 3) {
    return image
  }

  return { ...image, link: `${image.link.split('-DYN.png')[0]}-BRN-DYN.png` }

  // todo if we dont want them all to have bronze bushings, this next line needs to be used instead:
  // return { ...image, link: `${image.link.split('-DYN.png')[0]}-${BUSHING_MAP[this.options.bushing.val]}-DYN.png` }
}))

</script>
<style lang="scss" scoped>
</style>
